module.exports = __webpack_public_path__ + "static/4-3592b0d94f693a139dc9b9cc3afc5a72.png";